import { useTranslation } from "react-i18next";
import { CheckCircle, Package, Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";

interface Props {
  orderNumber?: number;
  product?: string;
  contactEmail?: string;
}

export function OrderConfirmation({ orderNumber, product, contactEmail }: Props) {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();

  const isAdresstwatt = product === "adresstwatt";

  return (
    <div className="flex flex-col items-center text-center py-16 space-y-8 max-w-lg mx-auto">
      <div className="p-5 rounded-full bg-primary/10">
        <CheckCircle className="h-14 w-14 text-primary" />
      </div>

      <div className="space-y-2">
        <h2 className="text-3xl font-semibold text-foreground">
          {isAdresstwatt ? t("order.adresstwatt.confirmationTitle") : t("order.confirmationTitle")}
        </h2>
        {orderNumber && (
          <p className="text-lg font-medium text-primary">
            {t("order.orderNumberLabel")}: GE{orderNumber}
          </p>
        )}
      </div>

      <div className="space-y-4 text-left w-full bg-muted/30 rounded-xl p-6">
        <div className="flex items-start gap-3">
          <Package className="h-5 w-5 text-primary shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground">{t("order.confirmationProductLabel")}</p>
            <p className="text-sm text-muted-foreground">
              {isAdresstwatt ? t("products.adresstwatt.title") : (product?.toUpperCase() || "–")}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <Mail className="h-5 w-5 text-primary shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground">{t("order.confirmationEmailSent")}</p>
            <p className="text-sm text-muted-foreground">
              {t("order.confirmationEmailSentDesc", { email: contactEmail || "" })}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <Clock className="h-5 w-5 text-primary shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground">{t("order.confirmationNextStep")}</p>
            <p className="text-sm text-muted-foreground">
              {isAdresstwatt ? t("order.adresstwatt.confirmationNextStepDesc") : t("order.confirmationNextStepDesc")}
            </p>
          </div>
        </div>
      </div>

      <Button asChild>
        <Link to={getLocalizedPath("/")}>{t("order.backToHome")}</Link>
      </Button>
    </div>
  );
}
